/**
* Data model that represents a Time Block from possibleTimeBlocksWS data
*
* @class TimeBlockModel
*/
var TimeBlockModel = function (data) {
  var self;			// Convenience reference so the context of 'this' becomes clearer

  // Predicate this data model on the AbstractDataModel.
  // This establishes core functionality required of DataModels,
  // which can be overwritten by methods below.
  // Specifically, conversion of XML data to JSON
  AbstractDataModel.apply(self, arguments);

  self = this;

  // Observable variables represented by this data model
  self.displayDay = null;
  self.displayTime = ko.observable(null);
  self.durationLabel = null;
  self.durationUnits = null;
  self.durationValue = null;
  self.group = 0;		// Allows the object to be positioned in the UI
  self.groupLength = 0;		// ^^
  self.isOverlap = false;
  self._rawStart = ko.observable(null);
  self.start = ko.observable(null);
  self.timeStart = null;



	/**
	* Returns a Javascript Date Native object representing the end
	* date/time of the TimeBlockModel
	*
	* @method end
	* @return {Moment}
	*/
  self.end = function () {
    var s = self.start(),
      dt = new moment(self.getDate()),
      mins = self.durationValue;

    if (self.durationUnits != 'min') {
      mins *= 60;
    }

    dt.add(mins, 'minutes');

    return dt;
  };


	/**
	* @method getDate
	* @param {Boolean} bShift Whether to shift the timezone according to the selected TZ
	* @return {Moment | null} Javascript Native Date object
	*/
  self.getDate = function (bShift) {
    var s = self.start(),
      dt = new moment(s),
      tz = qcal.timeZoneControl.selectedTZ();

    if (tz) {
      dt.tz(tz.olson[0]);
    }

    return (dt.isValid()) ? dt : null;
  };


	/**
	* Generates the start time in a localized string
	*
	* @method getDisplayTime
	* @return {String} Returns the start time of the possible time block
	*                  in a localized string
	*/
  self.getDisplayTime = function () {
    var s = self.start(),
      dt = self.getDate();

    return (dt) ? dt.format('LT') : null;
  };


	/**
	* Determines the CSS classes to paint on the DOM element representing
	* the possible time block
	*
	* @method timeblockCSS
	* @return {String} Returns a string of CSS class names
	*/
  self.timeblockCSS = function () {
    var aReturn = [];

    // This class allows the appointment interface to be positioned relatively in
    // the week view

    // This class allows the appointment to appear relative in size to the scale
    // of the day or week interface
    aReturn.push('starttime-' + self.timeblockStart());
    aReturn.push('appt-duration-' + self.durationValue);

    if (self.isOverlap) {
      aReturn.push('timeblock-overlap');
    }

    if (qcal.globalViewType() === 'openavailability') {
      aReturn.push('no-select');
    }

    return aReturn.join(' ');
  };




	/**
	* Creates CSS style declarations to position the element
	*
	* @method timeblockStyle
	* @return {String} Returns a string of CSS style attributes
	*/
  self.timeblockStyle = function () {
    var aReturn = [],
      left = 0;

    if (self.isOverlap) {
      aReturn.push('width:' + ((100 / self.groupLength) - 1) + '%');
      aReturn.push('left:' + ((100 / self.groupLength) * self.group) + '%');
      aReturn.push('group:' + self.group);
      aReturn.push('groupLen:' + self.groupLength);
    }

    return aReturn.join(';');
  };


	/**
	* Determines the string of the start time of the possible time block
	*
	* @method timeblockStart
	* @return {String} Returns a string representing the 24-hour time
	*                  start of the possible time block
	*/
  self.timeblockStart = ko.computed(function () {
    var s = self.start(),
      iMins = 0,
      sTimeblockStartString = '';

    if (self.getDate() != null) {
      sTimeblockStartString = self.getDate().format('H');
      iMins = self.getDate().minutes();

      if (iMins > 0) {
        sTimeblockStartString += self.getDate().format('mm');
      }

      return sTimeblockStartString;
    }

    return null;
  });


	/**
	* Method to convert the XML data representing this DataModel
	* into observed variables above.
	*
	* @method loadData
	* @param {XMLString} data XML String representing this model's data
	* @return {TimeBlockModel} Returns the data model as chainable, for best practice
	*/
  self.loadData = function (data) {
    // Call the superclass method of the same name
    // This loads the XML into the object's data member
    // and converts the data into JSON for easy assignment
    AbstractDataModel.prototype.loadData.call(self, data);

    self.start(self.json.start);
    self._rawStart(self.json.start);
    self.displayDay = self.json.displayDay;

    self.durationValue = parseInt(self.json.duration.duration, 0);
    self.durationUnits = self.json.duration.units;
    self.durationLabel = self.json.duration.text;

    if (self.durationUnits.toLowerCase() == 'hr' || self.durationUnits.toLowerCase() == 'hrs') {
      self.durationUnits = 'min';
      self.durationValue = 60 * self.durationValue;
    }

    // Return self (TimeBlockModel) to be chainable, for best practice
    return self;
  };


  // If the model was initialized with a data parameter,
  // call the loadData method to populate the observed variables.
  if (data) {
    self.loadData(data);
  }




  // Return self (TimeBlockModel) to be chainable, for best practice
  return self;
};

TimeBlockModel.prototype = AbstractDataModel.prototype;
TimeBlockModel.prototype.constructor = TimeBlockModel;
